import { useQuery } from '@tanstack/react-query'
import { providerApiClient } from '@/lib/api'
import { onboardingKeys, paymentsKeys } from '@/lib/queryKeys'

export function useStripeAccountStatus() {
  return useQuery({
    queryKey: onboardingKeys.stripeStatus(),
    queryFn: () => providerApiClient.getStripeAccountStatus(),
    staleTime: 30 * 1000,
  })
}

export function useRevenueSummary() {
  return useQuery({
    queryKey: paymentsKeys.summary(),
    queryFn: () => providerApiClient.getRevenueSummary(),
    staleTime: 60 * 1000,
  })
}

export function useRevenueHistory(months: number = 12) {
  return useQuery({
    queryKey: paymentsKeys.history(months),
    queryFn: () => providerApiClient.getRevenueHistory(months),
    staleTime: 60 * 1000,
  })
}
